__webpack_require__.p = "/MyMessageContract-Web/";